export default __webpack_public_path__ + "static/13-5c2fd5ec583cf60c93c5a247a308deb9.svg";